import React from 'react'
import styled from 'styled-components'

import { DEFAULT_LANG } from 'config/languages'
import Link from 'components/Link'
import { ReactComponent as Logo } from 'assets/svg/phoenix_logo.svg'

export function MainLogo({ lang }) {
   return (
      <StyledLogo url={lang === DEFAULT_LANG ? `/` : `/${lang}/`} type="internal" aria-label="Link to homepage">
         <Logo />
      </StyledLogo>
   )
}

const StyledLogo = styled(Link)`
   width: 100%;
   height: 100%;
   color: inherit;
   perspective: 1000px;
   display: block;
   width: 20px;
   height: 17px;
   svg {
      display: block;
      width: 100%;
      height: 100%;
      transition: transform 0.6s;
   }

   &:hover svg {
      transform: rotateY(180deg);
   }
`
